// The five rooms of the exhibition. Deep routes belong to a room; the Rail shows which.
export const ROOMS = [
  { id: "prismpixel", word: "PrismPixel", numeral: "I", glyph: "point", to: "/#room-prismpixel" },
  { id: "glass", word: "Glass", numeral: "II", glyph: "hairline", to: "/#room-glass" },
  { id: "glow", word: "Glow", numeral: "III", glyph: "disc", to: "/#room-glow" },
  { id: "creators", word: "Creators", numeral: "IV", glyph: "cluster", to: "/#room-creators" },
  { id: "laboratory", word: "Laboratory", numeral: "V", glyph: "crosshair", to: "/#room-laboratory" },
];

const ROUTE_ROOMS = [
  [/^\/(lab|technology|knowledge|document|formulations|topography|threshold|archive)(\/|$)/, "laboratory"],
  [/^\/(retrospective|films|collaborate|makers|commons|submit|samples|about\/testing|payment)(\/|$)/, "creators"],
  [/^\/about(\/|$)/, "prismpixel"],
];

export const roomForPath = (pathname) => {
  for (const [re, id] of ROUTE_ROOMS) if (re.test(pathname)) return id;
  return null;
};
